import type { SearchTerm } from '@libs/trip-planner-interfaces';
import { SearchTermType } from '@libs/trip-planner-interfaces';

export function getSearchTerm(constraint: {
  polygonId?: number;
  hotelCode?: string;
  freeText?: string;
}): SearchTerm {
  if (constraint.hotelCode) {
    return { type: SearchTermType.HotelCode, hotelCode: constraint.hotelCode };
  }

  if (constraint.polygonId) {
    return { type: SearchTermType.PolygonId, polygonId: constraint.polygonId };
  }

  if (constraint.freeText) {
    return {
      type: SearchTermType.FreeText,
      freeText: constraint.freeText,
    };
  }

  throw new Error('Invalid constraint type');
}
